import { render, staticRenderFns } from "./SparePartType.vue?vue&type=template&id=94dbf508"
import script from "./SparePartType.vue?vue&type=script&lang=ts"
export * from "./SparePartType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports